import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { FC } from 'react';
import { Page } from '../../Page';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const AchievementViewPageSkeleton: FC = () => {
  return (
    <Page back={true} insetEnabled={false}>
      <Stack height="100%">
        <Stack alignItems="center" justifyContent="center" minHeight="var(--tg-viewport-content-safe-area-inset-top)">
          <Text size={20}>View Achievement</Text>
        </Stack>
        <Stack paddingLeft="10px" paddingRight="10px" paddingTop="4px" gap={2}>
          <Stack alignSelf="center" sx={{ py: 2 }}>
            <Box sx={{ width: 100, height: 140 }}>
              <ThemedSkeleton variant="rectangular" width={100} height={140} 
                sx={{
                  borderRadius: '12px 12px 30px 30px'
                }} />
            </Box>
          </Stack>
          
          <ThemedSkeleton variant="text" width="60%" height={36} />
          <ThemedSkeleton variant="text" width="100%" height={30} />
          <ThemedSkeleton variant="text" width={100} height={30} />

          <Stack gap={1} sx={{ mt: 1 }}>
            <ThemedSkeleton variant="rectangular" width="100%" height={70} sx={{ borderRadius: '12px' }} />
          </Stack>
        </Stack>
      </Stack>
    </Page>
  );
};

